import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yoles_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function photoUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//.test(pathOrUrl)) return pathOrUrl;
  // Photo URLs from upload endpoint start with /api/photos/...
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return pathOrUrl;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(", ");
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return JSON.stringify(detail);
}

/** Format an ISO date/time in Martinique local time (AST, UTC-4, no DST).
 * Useful for showing race start / bet closure time, which is anchored to
 * the local race day regardless of the user's timezone. */
export function formatMartiniqueDateTime(iso, opts = {}) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      timeZone: "America/Martinique",
      weekday: opts.weekday || "long",
      day: "numeric",
      month: opts.month || "long",
      year: opts.year || undefined,
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch { return new Date(iso).toLocaleString("fr-FR"); }
}

/** Short date only, in Martinique local time. */
export function formatMartiniqueDate(iso, opts = {}) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      timeZone: "America/Martinique",
      weekday: opts.weekday || "short",
      day: "numeric",
      month: opts.month || "short",
      year: opts.year || undefined,
    });
  } catch { return new Date(iso).toLocaleDateString("fr-FR"); }
}

export default api;
